import { IAiReceptionistSettings } from '@dataTypes/ai.type'
import axios from './axiosConfig'
import { getEnv } from '@utils/env'

const AI_BUSINESS_API = getEnv('REACT_APP_BUSINESS_LAYER_AI')

interface ApiEnvelope<T> {
  statusCode: number
  message: string
  data: T
}

const BUSINESS_LAYER_API = `${AI_BUSINESS_API}/api/v1/ai/settings/ai-receptionist`

export const fetchAiReceptionistSettingsApi = async (
  clinicId: string,
): Promise<
  ApiEnvelope<{ ai_receptionist_settings: IAiReceptionistSettings }>
> => {
  const response = await axios.get(BUSINESS_LAYER_API, {
    params: { clinic_id: clinicId },
  })
  return response.data
}

export const saveAiReceptionistSettingsApi = async (
  clinicId: string,
  _settings: Partial<IAiReceptionistSettings>,
): Promise<
  ApiEnvelope<{ ai_receptionist_settings: IAiReceptionistSettings }>
> => {
  const user = localStorage.getItem('user')
  if (!user) {
    throw new Error('User not found')
  }
  const userData = JSON.parse(user)
  const userId = userData.user_id ?? ''
  const settings = {
    ..._settings,
    clinic_id: clinicId,
    created_by: userId,
    updated_by: userId,
  }
  const response = await axios.put(BUSINESS_LAYER_API, {
    clinic_id: clinicId,
    settings,
  })
  return response.data
}

export const previewAiReceptionistVoiceApi = async (
  voiceStyle: string,
  voiceTone: string,
  text?: string,
): Promise<Blob> => {
  const response = await axios.post(
    BUSINESS_LAYER_API + '/preview',
    { voice_style: voiceStyle, voice_tone: voiceTone, text },
    { responseType: 'blob' },
  )
  return response.data
}

export type AiReceptionistPatientRow = {
  patient_id: string
  patient_name: string
  status: string
  patient_status: number | null
  email: string
}

export type AiReceptionistAppointmentRow = {
  id: string
  appointment_id: string
  patient_id: string
  patient_name: string
  provider_name: string
  date: string
  time: string
  time_end: string
  subcategory: string
  status: string
  appt_status: number | null
}

export const fetchAiReceptionistActorApi = async (): Promise<
  ApiEnvelope<{ user_id: string }>
> => {
  const response = await axios.get(`${BUSINESS_LAYER_API}/actor`)
  return response.data
}

export const fetchAiReceptionistPatientsApi = async (
  clinicId: string,
): Promise<ApiEnvelope<{ patients: AiReceptionistPatientRow[] }>> => {
  const response = await axios.get(`${BUSINESS_LAYER_API}/patients`, {
    params: { clinic_id: clinicId },
  })
  return response.data
}

export const fetchAiReceptionistAppointmentsApi = async (
  clinicId: string,
): Promise<ApiEnvelope<{ appointments: AiReceptionistAppointmentRow[] }>> => {
  const response = await axios.get(`${BUSINESS_LAYER_API}/appointments`, {
    params: { clinic_id: clinicId },
  })
  return response.data
}
